<main class="settings-page">

  <header class="page-header">
    <div>
      <span class="page-label">
        Administração
      </span>

      <h1>Configurações</h1>

      <p>
        Gerencie os dados, a aparência e a segurança
        da sua conta.
      </p>
    </div>
  </header>


  <section class="settings-restaurant-selector">
    <div class="form-group">
      <label for="settingsRestaurant">
        Restaurante
      </label>

      <select class="input-style" id="settingsRestaurant" name="settingsRestaurant" [(ngModel)]="restaurantId"
        (change)="onRestaurantChange()" [disabled]="loadingRestaurants || loading">
        <option [ngValue]="null">
          Selecione um restaurante
        </option>

        <option *ngFor="let item of restaurants" [ngValue]="item.id">
          {{ item.name }}
        </option>
      </select>

      <small *ngIf="loadingRestaurants">
        Carregando restaurantes...
      </small>
    </div>
  </section>

  <div class="feedback success" *ngIf="successMessage">
    <span>✓</span>
    {{ successMessage }}
  </div>

  <div class="feedback error" *ngIf="errorMessage">
    <span>!</span>
    {{ errorMessage }}
  </div>

  <div class="loading-card" *ngIf="loadingRestaurants || loading">
    <span class="spinner dark"></span>
    Carregando configurações...
  </div>

  <div class="settings-layout" *ngIf="!loadingRestaurants && !loading && restaurantId">

    <aside class="settings-menu">

      <button type="button" [class.active]="activeSection === 'restaurant'" (click)="setSection('restaurant')">
        <span class="menu-icon">🏪</span>

        <span>
          <strong>Restaurante</strong>
          <small>Dados principais</small>
        </span>
      </button>

      <button type="button" [class.active]="activeSection === 'address'" (click)="setSection('address')">
        <span class="menu-icon">🔗</span>

        <span>
          <strong>Endereço</strong>
          <small>Link do cardápio</small>
        </span>
      </button>

      <button type="button" [class.active]="activeSection === 'appearance'" (click)="setSection('appearance')">
        <span class="menu-icon">🎨</span>

        <span>
          <strong>Aparência</strong>
          <small>Cores e logotipo</small>
        </span>
      </button>


      <button type="button" [class.active]="activeSection === 'hours'" (click)="setSection('hours')">
        <span class="menu-icon">🕐</span>

        <span>
          <strong>Funcionamento</strong>
          <small>Dias e horários</small>
        </span>
      </button>

      <button type="button" [class.active]="activeSection === 'team'" (click)="setSection('team')">
        <span class="menu-icon">👥</span>

        <span>
          <strong>Equipe</strong>
          <small>Convites e permissões</small>
        </span>
      </button>

      <button type="button" [class.active]="activeSection === 'security'" (click)="setSection('security')">
        <span class="menu-icon">🔒</span>

        <span>
          <strong>Segurança</strong>
          <small>Alteração de senha</small>
        </span>
      </button>

    </aside>

    <section class="settings-content">

      <!-- RESTAURANTE -->

      <article class="settings-section" *ngIf="activeSection === 'restaurant'">

        <div class="section-header">
          <div>
            <h2>Dados do restaurante</h2>

            <p>
              Essas informações poderão aparecer no
              cardápio dos seus clientes.
            </p>
          </div>
        </div>

        <div class="form-grid">

          <div class="form-group full">
            <label for="restaurantName">
              Nome do restaurante
            </label>

            <input id="restaurantName" name="restaurantName" [(ngModel)]="restaurant.name"
              (ngModelChange)="onRestaurantNameChange()" type="text" placeholder="Ex.: Pizzaria Central"
              maxlength="100">
          </div>

          <div class="form-group full">
            <label for="description">
              Descrição
            </label>

            <textarea id="description" name="description" [(ngModel)]="restaurant.description" rows="4" maxlength="300"
              placeholder="Conte um pouco sobre o restaurante"></textarea>

            <small class="character-count">
              {{ restaurant.description.length }}/300
            </small>
          </div>

          <div class="form-group">
            <label for="phone">
              Telefone
            </label>

            <input id="phone" name="phone" [(ngModel)]="restaurant.phone" type="tel" placeholder="(81) 3333-3333">
          </div>

          <div class="form-group">
            <label for="whatsapp">
              WhatsApp dos pedidos
            </label>

            <input id="whatsapp" name="whatsapp" [(ngModel)]="restaurant.whatsapp" type="tel"
              placeholder="(81) 99999-9999">

            <small>
              Os pedidos poderão ser enviados para este número.
            </small>
          </div>

          <div class="form-group full">
            <label for="restaurantEmail">
              E-mail de contato
            </label>

            <input id="restaurantEmail" name="restaurantEmail" [(ngModel)]="restaurant.email" type="email"
              placeholder="contato@restaurante.com">
          </div>

        </div>





        <!-- =========================
     ENTREGA
     ========================= -->

        <section class="delivery-settings">

          <div class="section-header delivery-header">

            <div>

              <h3>
                Configuração de entrega
              </h3>

              <p>
                Escolha como o valor da entrega
                será calculado para os seus clientes.
              </p>

            </div>

            <span class="delivery-icon">
              🛵
            </span>

          </div>


          <!-- TIPO DE TAXA -->

          <div class="delivery-type-grid">


            <!-- FIXA -->

            <label class="delivery-type-card" [class.selected]="
        restaurant.deliveryFeeType ===
        'FIXED'
      ">

              <input type="radio" name="deliveryFeeType" value="FIXED" [(ngModel)]="
          restaurant.deliveryFeeType
        " (change)="
          onDeliveryFeeTypeChange()
        ">

              <span class="delivery-radio"></span>

              <div>

                <strong>
                  Taxa fixa
                </strong>

                <small>
                  Use o mesmo valor de entrega
                  para todos os clientes.
                </small>

              </div>

            </label>


            <!-- CEP -->

            <label class="delivery-type-card" [class.selected]="
        restaurant.deliveryFeeType ===
        'ZIP_CODE'
      ">

              <input type="radio" name="deliveryFeeType" value="ZIP_CODE" [(ngModel)]="
          restaurant.deliveryFeeType
        " (change)="
          onDeliveryFeeTypeChange()
        ">

              <span class="delivery-radio"></span>

              <div>

                <strong>
                  Taxa por região / CEP
                </strong>

                <small>
                  Defina valores diferentes de acordo
                  com a região de entrega.
                </small>

              </div>

            </label>

          </div>


          <!-- =========================
       TAXA FIXA
       ========================= -->

          <div class="delivery-fixed-card" *ngIf="
      restaurant.deliveryFeeType ===
      'FIXED'
    ">

            <div class="form-group">

              <label for="deliveryFee">
                Taxa de entrega
              </label>

              <div class="money-input">

                <span>
                  R$
                </span>

                <input id="deliveryFee" name="deliveryFee" type="number" min="0" step="0.01" [(ngModel)]="
            restaurant.deliveryFee
          " placeholder="0,00">

              </div>

              <small>
                Este valor será aplicado somente
                aos pedidos para entrega.
                Mesa e retirada não possuem frete.
              </small>

            </div>

          </div>


          <!-- =========================
       TAXA POR CEP
       ========================= -->

          <div class="delivery-regions" *ngIf="
      restaurant.deliveryFeeType ===
      'ZIP_CODE'
    ">

            <div class="delivery-regions-header">

              <div>

                <strong>
                  Regiões de entrega
                </strong>

                <small>
                  Cadastre as faixas de CEP
                  atendidas pelo restaurante.
                </small>

              </div>


              <button type="button" class="secondary-button" (click)="
          addDeliveryRule()
        ">
                + Adicionar região
              </button>

            </div>


            <div class="loading-card" *ngIf="
        loadingDeliveryRules
      ">
              <span class="spinner dark"></span>

              Carregando regiões...
            </div>


            <div class="empty-state" *ngIf="
        !loadingDeliveryRules &&
        !deliveryRules.length
      ">

              <span>
                📍
              </span>

              <strong>
                Nenhuma região cadastrada
              </strong>

              <p>
                Adicione as regiões onde
                o restaurante realiza entregas.
              </p>

            </div>


            <!-- REGRA -->

            <div class="delivery-rule-card" *ngFor="
        let rule of deliveryRules;
        let i = index
      ">

              <div class="delivery-rule-title">

                <span class="delivery-rule-number">
                  {{ i + 1 }}
                </span>

                <strong>
                  {{
                  rule.name ||
                  'Nova região'
                  }}
                </strong>

              </div>


              <div class="delivery-rule-grid">


                <div class="form-group">

                  <label>
                    Nome da região
                  </label>

                  <input type="text" [name]="
              'deliveryRegionName' + i
            " [(ngModel)]="
              rule.name
            " placeholder="Ex.: Boa Viagem" maxlength="100">

                </div>


                <div class="form-group">

                  <label>
                    CEP inicial
                  </label>

                  <input type="text" inputmode="numeric" maxlength="9" [name]="
              'deliveryZipStart' + i
            " [(ngModel)]="
              rule.zipCodeStart
            " (input)="
              onZipCodeInput(
                rule,
                'zipCodeStart'
              )
            " placeholder="00000-000">

                </div>


                <div class="form-group">

                  <label>
                    CEP final
                  </label>

                  <input type="text" inputmode="numeric" maxlength="9" [name]="
              'deliveryZipEnd' + i
            " [(ngModel)]="
              rule.zipCodeEnd
            " (input)="
              onZipCodeInput(
                rule,
                'zipCodeEnd'
              )
            " placeholder="00000-000">

                </div>


                <div class="form-group">

                  <label>
                    Taxa
                  </label>

                  <div class="money-input">

                    <span>
                      R$
                    </span>

                    <input type="number" min="0" step="0.01" [name]="
                'deliveryFeeRule' + i
              " [(ngModel)]="
                rule.fee
              " placeholder="0,00">

                  </div>

                </div>

              </div>


              <div class="delivery-rule-footer">

                <label class="delivery-active">

                  <input type="checkbox" [name]="
              'deliveryRuleActive' + i
            " [(ngModel)]="
              rule.isActive
            ">

                  <span>
                    Região ativa
                  </span>

                </label>


                <div class="delivery-rule-actions">

                  <button type="button" class="danger-button" (click)="
              removeDeliveryRule(
                rule,
                i
              )
            ">
                    Excluir
                  </button>


                  <button type="button" class="secondary-button" [disabled]="
              savingDeliveryRule
            " (click)="
              saveDeliveryRule(
                rule
              )
            ">

                    {{
                    savingDeliveryRule
                    ? 'Salvando...'
                    : 'Salvar região'
                    }}

                  </button>

                </div>

              </div>

            </div>

          </div>


          <!-- SALVAR CONFIGURAÇÃO -->

          <div class="delivery-settings-footer">

            <button type="button" class="primary-button" [disabled]="
        savingDeliverySettings ||
        !restaurantId
      " (click)="
        saveDeliverySettings()
      ">

              <span class="spinner" *ngIf="
          savingDeliverySettings
        "></span>

              {{
              savingDeliverySettings
              ? 'Salvando...'
              : 'Salvar configuração de entrega'
              }}

            </button>

          </div>

        </section>








        <div class="section-footer">
          <button type="button" class="primary-button" [disabled]="savingRestaurant || !restaurantId"
            (click)="saveRestaurant()">
            <span class="spinner" *ngIf="savingRestaurant"></span>

            {{
            savingRestaurant
            ? 'Salvando...'
            : 'Salvar alterações'
            }}
          </button>
        </div>

      </article>

      <!-- ENDEREÇO -->

      <article class="settings-section" *ngIf="activeSection === 'address'">

        <div class="section-header">
          <div>
            <h2>Endereço do cardápio</h2>

            <p>
              Escolha o endereço que será enviado aos
              seus clientes.
            </p>
          </div>
        </div>

        <div class="address-preview">
          <span>Seu cardápio ficará disponível em:</span>

          <strong>{{ publicMenuUrl }}</strong>
        </div>

        <div class="form-group full">
          <label for="slug">
            Endereço personalizado
          </label>

          <div class="domain-input" [class.available]="slugAvailable === true"
            [class.unavailable]="slugAvailable === false">
            <span>{{ platformDomain }}/</span>

            <input id="slug" name="slug" [(ngModel)]="restaurant.slug" (ngModelChange)="onSlugChange()" type="text"
              maxlength="60" placeholder="nome-do-restaurante">

            <span class="checking" *ngIf="checkingSlug">
              Verificando...
            </span>

            <span class="available-icon" *ngIf="
                !checkingSlug &&
                slugAvailable === true
              ">
              ✓
            </span>
          </div>

          <small class="status-message success-text" *ngIf="slugAvailable === true">
            Este endereço está disponível.
          </small>

          <small class="status-message error-text" *ngIf="slugError">
            {{ slugError }}
          </small>
        </div>

        <div class="suggestions" *ngIf="slugSuggestions.length">
          <span>Sugestões disponíveis:</span>

          <div class="suggestion-list">
            <button type="button" *ngFor="let suggestion of slugSuggestions" (click)="selectSlugSuggestion(suggestion)">
              {{ suggestion }}
            </button>
          </div>
        </div>

        <div class="info-card">
          <span>💡</span>

          <div>
            <strong>Escolha com atenção</strong>

            <p>
              Ao alterar o endereço, links antigos enviados
              aos seus clientes poderão deixar de funcionar.
            </p>
          </div>
        </div>

        <div class="section-footer">
          <button type="button" class="primary-button" [disabled]="
              savingAddress ||
              !restaurantId ||
              checkingSlug ||
              slugAvailable !== true
            " (click)="saveAddress()">
            <span class="spinner" *ngIf="savingAddress"></span>

            {{
            savingAddress
            ? 'Salvando...'
            : 'Salvar endereço'
            }}
          </button>
        </div>

      </article>



      <!-- APARÊNCIA -->

      <article class="settings-section" *ngIf="activeSection === 'appearance'">

        <div class="section-header">

          <div>

            <h2>
              Aparência do cardápio
            </h2>

            <p>
              Personalize as imagens e as cores
              do cardápio do restaurante.
            </p>

          </div>

        </div>


        <div class="appearance-layout">

          <!-- =========================
         CONFIGURAÇÕES
         ========================= -->

          <div class="appearance-form">


            <!-- =========================
           IMAGENS
           ========================= -->

            <div class="appearance-images">


              <!-- LOGOTIPO -->

              <div class="appearance-upload-card">

                <div class="upload-title">

                  <div>
                    <strong>
                      Logotipo
                    </strong>

                    <small>
                      Será exibido no cabeçalho,
                      cardápio e carrinho.
                    </small>
                  </div>

                  <span class="upload-badge">
                    Logo
                  </span>

                </div>


                <label class="appearance-upload logo-upload" [class.has-image]="restaurant.logoUrl">

                  <input type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="uploadLogo($event)">


                  <img *ngIf="restaurant.logoUrl" [src]="restaurant.logoUrl" class="appearance-logo-preview"
                    alt="Logotipo do restaurante">


                  <div class="upload-empty" *ngIf="!restaurant.logoUrl">

                    <span class="upload-empty-icon">
                      📷
                    </span>

                    <strong>
                      Escolher logotipo
                    </strong>

                    <small>
                      JPG, PNG ou WEBP
                    </small>

                  </div>

                </label>


                <div class="appearance-image-actions" *ngIf="restaurant.logoUrl">

                  <label class="change-image-link">

                    <span>
                      📷
                    </span>

                    Trocar logotipo

                    <input type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="uploadLogo($event)">

                  </label>

                </div>

              </div>


              <!-- CAPA -->

              <div class="appearance-upload-card">

                <div class="upload-title">

                  <div>
                    <strong>
                      Imagem de capa
                    </strong>

                    <small>
                      Utilize uma imagem horizontal
                      que represente o restaurante.
                    </small>
                  </div>

                  <span class="upload-badge">
                    Capa
                  </span>

                </div>


                <label class="appearance-upload cover-upload" [class.has-image]="restaurant.coverUrl">

                  <input type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="uploadCover($event)">


                  <img *ngIf="restaurant.coverUrl" [src]="restaurant.coverUrl" class="appearance-cover-preview"
                    alt="Imagem de capa do restaurante">


                  <div class="upload-empty" *ngIf="!restaurant.coverUrl">

                    <span class="upload-empty-icon">
                      🖼️
                    </span>

                    <strong>
                      Escolher imagem de capa
                    </strong>

                    <small>
                      JPG, PNG ou WEBP
                    </small>

                  </div>

                </label>


                <div class="appearance-image-actions" *ngIf="restaurant.coverUrl">

                  <label class="change-image-link">

                    <span>
                      🖼️
                    </span>

                    Trocar imagem

                    <input type="file" accept="image/jpeg,image/png,image/webp" hidden (change)="uploadCover($event)">

                  </label>

                </div>

              </div>

            </div>


            <!-- =========================
           CORES
           ========================= -->

            <div class="appearance-colors-section">

              <div class="appearance-subtitle">

                <div>

                  <strong>
                    Identidade visual
                  </strong>

                  <small>
                    Essas cores serão aplicadas
                    automaticamente no cardápio público.
                  </small>

                </div>

                <span>
                  🎨
                </span>

              </div>


              <div class="color-grid">


                <!-- COR PRINCIPAL -->

                <div class="form-group">

                  <label for="primaryColor">
                    Cor principal
                  </label>

                  <div class="color-control">

                    <input id="primaryColor" name="primaryColor" [(ngModel)]="restaurant.primaryColor" type="color">

                    <input [(ngModel)]="restaurant.primaryColor" name="primaryColorText" type="text" maxlength="7"
                      placeholder="#ff6b00">

                  </div>

                  <small>
                    Botões, destaques, ícones
                    e elementos principais.
                  </small>

                </div>


                <!-- COR SECUNDÁRIA -->

                <div class="form-group">

                  <label for="secondaryColor">
                    Cor secundária
                  </label>

                  <div class="color-control">

                    <input id="secondaryColor" name="secondaryColor" [(ngModel)]="restaurant.secondaryColor"
                      type="color">

                    <input [(ngModel)]="restaurant.secondaryColor" name="secondaryColorText" type="text" maxlength="7"
                      placeholder="#171717">

                  </div>

                  <small>
                    Títulos, áreas escuras
                    e elementos de apoio.
                  </small>

                </div>

              </div>

            </div>


          </div>


          <!-- =========================
         PRÉ-VISUALIZAÇÃO
         ========================= -->

          <div class="menu-preview">

            <span class="preview-label">
              Pré-visualização
            </span>


            <div class="preview-phone">


              <!-- CAPA -->

              <div class="preview-cover" [style.backgroundColor]="
            restaurant.primaryColor
          " [style.backgroundImage]="
            restaurant.coverUrl
              ? 'url(' + restaurant.coverUrl + ')'
              : 'none'
          " [style.backgroundSize]="'cover'" [style.backgroundPosition]="'center'">

                <div class="preview-cover-overlay"></div>

              </div>


              <!-- CORPO -->

              <div class="preview-body">


                <!-- LOGO -->

                <div class="preview-logo" [style.background]="
              restaurant.secondaryColor
            ">

                  <img *ngIf="restaurant.logoUrl" [src]="restaurant.logoUrl" alt="Logotipo do restaurante">

                  <span *ngIf="!restaurant.logoUrl">
                    🍽️
                  </span>

                </div>


                <!-- CONTEÚDO -->

                <h3>
                  {{
                  restaurant.name ||
                  'Nome do restaurante'
                  }}
                </h3>


                <p>
                  {{
                  restaurant.description ||
                  'Descrição do seu restaurante'
                  }}
                </p>


                <!-- MINI CATEGORIAS -->

                <div class="preview-categories">

                  <span [style.background]="
                restaurant.primaryColor
              "></span>

                  <span></span>

                  <span></span>

                </div>


                <!-- PRODUTO FAKE -->

                <div class="preview-product">

                  <div class="preview-product-image" [style.background]="
                restaurant.primaryColor
              "></div>

                  <div class="preview-product-info">

                    <strong>
                      Produto do cardápio
                    </strong>

                    <small>
                      Descrição do produto
                    </small>

                    <b [style.color]="
                  restaurant.primaryColor
                ">
                      R$ 39,90
                    </b>

                  </div>

                </div>


                <button type="button" [style.background]="
              restaurant.primaryColor
            ">
                  Ver cardápio
                </button>

              </div>

            </div>

          </div>

        </div>


        <!-- =========================
       SALVAR
       ========================= -->

        <div class="section-footer">

          <button type="button" class="primary-button" [disabled]="
        savingAppearance ||
        !restaurantId
      " (click)="saveAppearance()">

            <span class="spinner" *ngIf="savingAppearance"></span>

            {{
            savingAppearance
            ? 'Salvando...'
            : 'Salvar cores'
            }}

          </button>

        </div>

      </article>





      <!-- =========================
     FUNCIONAMENTO
     ========================= -->

      <article class="settings-section" *ngIf="activeSection === 'hours'">

        <div class="section-header">
          <div>
            <h2>Funcionamento</h2>

            <p>
              Configure os dias e horários em que
              o restaurante recebe novos pedidos.
            </p>
          </div>
        </div>


        <!-- LOADING -->

        <div class="opening-loading" *ngIf="loadingOpeningHours">
          <span class="spinner dark"></span>
          Carregando horários...
        </div>


        <ng-container *ngIf="!loadingOpeningHours">

          <!-- ==================================
         STATUS MANUAL
         ================================== -->

          <div class="restaurant-open-control" [class.closed]="!restaurantOpen">

            <div class="restaurant-open-info">

              <div class="restaurant-status-icon" [class.closed]="!restaurantOpen">
                {{ restaurantOpen ? '✓' : '!' }}
              </div>

              <div>

                <strong>
                  {{
                  restaurantOpen
                  ? 'Restaurante liberado'
                  : 'Restaurante fechado manualmente'
                  }}
                </strong>

                <p *ngIf="restaurantOpen">
                  O funcionamento será definido pelos
                  horários configurados abaixo.
                </p>

                <p *ngIf="!restaurantOpen">
                  Nenhum novo pedido será aceito até
                  você liberar o restaurante novamente.
                </p>

              </div>

            </div>


            <button type="button" class="open-status-button" [class.close-button]="restaurantOpen"
              [class.open-button]="!restaurantOpen" [disabled]="savingOpenStatus"
              (click)="toggleRestaurantOpenStatus()">

              <span class="spinner" *ngIf="savingOpenStatus"></span>

              {{
              savingOpenStatus
              ? 'Alterando...'
              : restaurantOpen
              ? 'Fechar temporariamente'
              : 'Liberar restaurante'
              }}

            </button>

          </div>


          <!-- ==================================
         STATUS CALCULADO
         ================================== -->

          <div class="current-opening-status" *ngIf="openingStatus" [class.open]="openingStatus.isOpen"
            [class.closed]="!openingStatus.isOpen">

            <span class="status-dot"></span>

            <div>

              <strong>
                {{
                openingStatus.isOpen
                ? 'Aberto agora'
                : 'Fechado agora'
                }}
              </strong>

              <small *ngIf="
            openingStatus.isOpen &&
            openingStatus.closesAt
          ">
                Fecha às
                {{ openingStatus.closesAt }}
              </small>

              <small *ngIf="
            !openingStatus.isOpen &&
            openingStatus.message
          ">
                {{ openingStatus.message }}
              </small>

            </div>

          </div>


          <!-- ==================================
         FUSO
         ================================== -->

          <div class="opening-timezone">

            <div>
              <strong>Fuso horário</strong>

              <small>
                Usado para verificar automaticamente
                se o restaurante está aberto.
              </small>
            </div>

            <select name="restaurantTimezone" [(ngModel)]="restaurantTimezone">
              <option value="America/Recife">
                Recife / Brasília
              </option>

              <option value="America/Sao_Paulo">
                São Paulo / Brasília
              </option>

              <option value="America/Manaus">
                Manaus
              </option>

              <option value="America/Rio_Branco">
                Rio Branco
              </option>
            </select>

          </div>


          <!-- ==================================
         SEMANA
         ================================== -->

          <div class="opening-week">

            <div class="opening-week-header">

              <div>
                <h3>
                  Horários de funcionamento
                </h3>

                <p>
                  Você pode adicionar mais de um período
                  de funcionamento no mesmo dia.
                </p>
              </div>

            </div>


            <!-- DIA -->

            <div class="opening-day" *ngFor="
          let day of openingHours;
          let dayIndex = index
        " [class.day-closed]="!day.isOpen">

              <div class="opening-day-main">

                <div class="opening-day-name">

                  <button type="button" class="day-toggle" [class.active]="day.isOpen" (click)="toggleOpeningDay(day)">
                    <span></span>
                  </button>


                  <div>

                    <strong>
                      {{
                      weekDays[dayIndex]
                      ?.label
                      }}
                    </strong>

                    <small>
                      {{
                      day.isOpen
                      ? 'Aberto'
                      : 'Fechado'
                      }}
                    </small>

                  </div>

                </div>


                <button type="button" class="add-period-button" *ngIf="day.isOpen" (click)="addOpeningPeriod(day)">
                  + Adicionar horário
                </button>

              </div>


              <!-- PERÍODOS -->

              <div class="opening-periods" *ngIf="day.isOpen">

                <div class="opening-period" *ngFor="
              let period of day.periods;
              let periodIndex = index
            ">

                  <div class="time-field">

                    <label>
                      Abre
                    </label>

                    <input type="time" [name]="
                  'openTime' +
                  dayIndex +
                  '_' +
                  periodIndex
                " [(ngModel)]="
                  period.openTime
                ">

                  </div>


                  <span class="time-separator">
                    até
                  </span>


                  <div class="time-field">

                    <label>
                      Fecha
                    </label>

                    <input type="time" [name]="
                  'closeTime' +
                  dayIndex +
                  '_' +
                  periodIndex
                " [(ngModel)]="
                  period.closeTime
                ">

                  </div>


                  <button type="button" class="remove-period-button" title="Remover horário" (click)="
                removeOpeningPeriod(
                  day,
                  periodIndex
                )
              ">
                    ×
                  </button>

                </div>

              </div>

            </div>

          </div>


          <!-- AVISO -->

          <div class="opening-info-card">

            <span>💡</span>

            <div>

              <strong>
                Horários após meia-noite
              </strong>

              <p>
                Você também pode configurar horários
                como 18:00 até 02:00. O sistema entende
                automaticamente que o funcionamento
                continua no dia seguinte.
              </p>

            </div>

          </div>


          <!-- SALVAR -->

          <div class="section-footer">

            <button type="button" class="primary-button" [disabled]="
          savingOpeningHours ||
          !restaurantId
        " (click)="saveOpeningHours()">

              <span class="spinner" *ngIf="savingOpeningHours"></span>

              {{
              savingOpeningHours
              ? 'Salvando...'
              : 'Salvar horários'
              }}

            </button>

          </div>

        </ng-container>

      </article>











      <!-- EQUIPE -->

      <article class="settings-section" *ngIf="activeSection === 'team'">
        <div class="section-header">
          <div>
            <h2>Equipe e acessos</h2>

            <p>
              Convide pessoas para ajudar na administração
              do restaurante e defina o nível de acesso.
            </p>
          </div>
        </div>

        <div class="info-card">
          <span>🔐</span>

          <div>
            <strong>Acesso protegido</strong>

            <p>
              O convite deve ser aceito pelo e-mail informado.
              As permissões também precisam ser validadas pelo
              backend em cada requisição.
            </p>
          </div>
        </div>

        <section class="team-invite-card">
          <div class="section-header">
            <div>
              <h3>Convidar novo membro</h3>

              <p>
                Informe o e-mail e escolha a função da pessoa.
              </p>
            </div>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label for="invitationEmail">
                E-mail do convidado
              </label>

              <input id="invitationEmail" name="invitationEmail" type="email" [(ngModel)]="invitationEmail"
                placeholder="pessoa@email.com" autocomplete="email" maxlength="150">
            </div>

            <div class="form-group">
              <label for="invitationRole">
                Função
              </label>

              <select class="input-style" id="invitationRole" name="invitationRole" [(ngModel)]="invitationRole">
                <option *ngFor="let role of teamRoleOptions" [ngValue]="role.value">
                  {{ role.label }}
                </option>
              </select>

              <small>
                {{ selectedInvitationRoleDescription }}
              </small>
            </div>
          </div>

          <div class="section-footer">
            <button type="button" class="primary-button" [disabled]="
                invitingMember ||
                !restaurantId ||
                !invitationEmail.trim()
              " (click)="sendInvitation()">
              <span class="spinner" *ngIf="invitingMember"></span>

              {{
              invitingMember
              ? 'Enviando...'
              : 'Enviar convite'
              }}
            </button>
          </div>
        </section>

        <div class="loading-card" *ngIf="loadingTeam">
          <span class="spinner dark"></span>
          Carregando equipe...
        </div>

        <ng-container *ngIf="!loadingTeam">
          <section class="team-list-card">
            <div class="section-header">
              <div>
                <h3>Membros da equipe</h3>

                <p>
                  Pessoas que já possuem acesso ao restaurante.
                </p>
              </div>

              <span class="team-count">
                {{ teamMembers.length }}
              </span>
            </div>

            <div class="empty-state" *ngIf="!teamMembers.length">
              <span>👤</span>
              <strong>Nenhum membro encontrado</strong>
              <p>
                Envie o primeiro convite para montar sua equipe.
              </p>
            </div>

            <div class="team-member-row" *ngFor="let member of teamMembers">
              <div class="member-avatar">
                {{
                (member.name || member.email)
                .charAt(0)
                .toUpperCase()
                }}
              </div>

              <div class="member-info">
                <strong>
                  {{ member.name || 'Usuário convidado' }}
                </strong>

                <span>{{ member.email }}</span>
              </div>

              <div class="member-role">
                <span class="owner-badge" *ngIf="member.role === 'OWNER'">
                  Proprietário
                </span>

                <select *ngIf="member.role !== 'OWNER'" [(ngModel)]="member.role" [name]="'memberRole' + member.id"
                  [disabled]="
                    updatingMemberId === member.id ||
                    removingMemberId === member.id
                  " (change)="updateMemberRole(member)">
                  <option *ngFor="let role of teamRoleOptions" [ngValue]="role.value">
                    {{ role.label }}
                  </option>
                </select>
              </div>

              <button *ngIf="member.role !== 'OWNER'" type="button" class="danger-button" [disabled]="
                  removingMemberId === member.id ||
                  updatingMemberId === member.id
                " (click)="removeMember(member)">
                {{
                removingMemberId === member.id
                ? 'Removendo...'
                : 'Remover'
                }}
              </button>
            </div>
          </section>

          <section class="team-list-card">
            <div class="section-header">
              <div>
                <h3>Convites enviados</h3>

                <p>
                  Acompanhe os convites que ainda não foram aceitos.
                </p>
              </div>

              <span class="team-count">
                {{ teamInvitations.length }}
              </span>
            </div>

            <div class="empty-state" *ngIf="!teamInvitations.length">
              <span>✉️</span>
              <strong>Nenhum convite pendente</strong>
              <p>
                Os convites enviados aparecerão nesta área.
              </p>
            </div>

            <div class="invitation-row" *ngFor="let invitation of teamInvitations">
              <div class="member-avatar invitation-avatar">
                ✉
              </div>

              <div class="member-info">
                <strong>{{ invitation.email }}</strong>

                <span>
                  {{ getRoleLabel(invitation.role) }}
                  ·
                  {{ getInvitationStatusLabel(invitation.status) }}
                </span>

                <small *ngIf="invitation.createdAt">
                  Enviado em
                  {{ formatInvitationDate(invitation.createdAt) }}
                </small>
              </div>

              <button *ngIf="invitation.status === 'PENDING'" type="button" class="danger-button" [disabled]="
                  cancellingInvitationId === invitation.id
                " (click)="cancelInvitation(invitation)">
                {{
                cancellingInvitationId === invitation.id
                ? 'Cancelando...'
                : 'Cancelar'
                }}
              </button>
            </div>
          </section>
        </ng-container>
      </article>

      <!-- SEGURANÇA -->

      <article class="settings-section" *ngIf="activeSection === 'security'">

        <div class="section-header">
          <div>
            <h2>Alterar senha</h2>

            <p>
              Use uma senha forte e diferente das utilizadas
              em outros sistemas.
            </p>
          </div>
        </div>

        <div class="security-form">

          <div class="form-group full">
            <label for="currentPassword">
              Senha atual
            </label>

            <div class="password-input">
              <input id="currentPassword" name="currentPassword" [(ngModel)]="currentPassword" [type]="
                  showCurrentPassword
                    ? 'text'
                    : 'password'
                " autocomplete="current-password">

              <button type="button" (click)="
                  showCurrentPassword =
                    !showCurrentPassword
                ">
                {{
                showCurrentPassword
                ? 'Ocultar'
                : 'Mostrar'
                }}
              </button>
            </div>
          </div>

          <div class="form-group full">
            <label for="newPassword">
              Nova senha
            </label>

            <div class="password-input">
              <input id="newPassword" name="newPassword" [(ngModel)]="newPassword" [type]="
                  showNewPassword
                    ? 'text'
                    : 'password'
                " autocomplete="new-password">

              <button type="button" (click)="
                  showNewPassword =
                    !showNewPassword
                ">
                {{
                showNewPassword
                ? 'Ocultar'
                : 'Mostrar'
                }}
              </button>
            </div>

            <div class="password-strength" *ngIf="newPassword">
              <div class="strength-bars">
                <span *ngFor="let item of [1, 2, 3, 4, 5]" [class.active]="
                    passwordStrength >= item
                  "></span>
              </div>

              <small>
                Força da senha:
                <strong>
                  {{ passwordStrengthLabel }}
                </strong>
              </small>
            </div>
          </div>

          <div class="form-group full">
            <label for="confirmPassword">
              Confirmar nova senha
            </label>

            <div class="password-input">
              <input id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" [type]="
                  showConfirmPassword
                    ? 'text'
                    : 'password'
                " autocomplete="new-password">

              <button type="button" (click)="
                  showConfirmPassword =
                    !showConfirmPassword
                ">
                {{
                showConfirmPassword
                ? 'Ocultar'
                : 'Mostrar'
                }}
              </button>
            </div>
          </div>
          <div class="password-rules">
            <strong>A senha deve possuir:</strong>

            <span [class.valid]="hasMinimumLength">
              ✓ Pelo menos 8 caracteres
            </span>

            <span [class.valid]="hasUppercase">
              ✓ Uma letra maiúscula
            </span>

            <span [class.valid]="hasLowercase">
              ✓ Uma letra minúscula
            </span>

            <span [class.valid]="hasNumber">
              ✓ Um número
            </span>

            <span [class.valid]="hasSpecialCharacter">
              ✓ Um caractere especial
            </span>
          </div>

        </div>

        <div class="section-footer">
          <button type="button" class="primary-button" [disabled]="changingPassword" (click)="changePassword()">
            <span class="spinner" *ngIf="changingPassword"></span>

            {{
            changingPassword
            ? 'Alterando...'
            : 'Alterar senha'
            }}
          </button>
        </div>

      </article>

    </section>

  </div>

</main>